/*
  教室选择时将教室数据存储
  进入对应设备类型时设备数据存储
 */
const CLASSROOM_DATA_CHANGE = "CLASSROOM_DATA_CHANGE"
const DEVICE_DATA_CHANGE = "DEVICE_DATA_CHANGE"

export default {
  CLASSROOM_DATA_CHANGE,
  DEVICE_DATA_CHANGE
}



// WEBPACK FOOTER //
// ./src/store/types.js